<template>
  <div class="container">
    <div class="decrypt-panel">
      <div class="decrypt-tip">
        请使用标证通 App 扫码完成投保数据解密
      </div>
      <a-button
        type="primary"
        size="large"
        class="btnBX"
        @click="btnBX"
      >
        标证通解密
      </a-button>
    </div>
    <a-modal
      class="rules"
      v-model="tipShow"
      title=""
      centered
      :mask-closable="false"
    >
      <img
        id="zxjHhdbQrcodeImage"
        alt="标证通二维码"
        v-show="qrcodeImageShow"
      >
      <template v-slot:footer />
    </a-modal>
  </div>
</template>

<script>
/* global QRCode */
import apis from '@/api/insurePreZxjHhdb.js';
const {
  buildBztQrcodeParams,
  buildBztQueryParams,
  extractBztQrContent,
} = require('./decryptors');
export default {
  name: 'InsurePreZxjHhdb',
  components: {

  },
  data() {
    return {
      qrcodeImageShow: false,
      qrcodeid: '',
      timer: null,
      tipShow: false,
    };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    async btnBX() {
      const that = this;
      this.tipShow = true;
      await apis.getQrcode(buildBztQrcodeParams(this.$route.query.orderNo)).then(({ data: data }) => {
        this.qrcodeImageShow = true;
        const qrInfo = extractBztQrContent(data);
        that.qrcodeid = qrInfo.qrcodeid;
        const imageElement = document.getElementById('zxjHhdbQrcodeImage');
        QRCode.toDataURL(qrInfo.content, function(error, url) {
          if (error) {
            console.error(error);
          } else {
            imageElement.src = url;
            that.GetqueryResult();
          }
        });
      });
    },
    GetqueryResult() {
      const that = this;
      clearTimeout(that.timer);
      apis.getQueryResult(buildBztQueryParams(this.$route.query.orderNo, that.qrcodeid)).then(({ data: data }) => {
        if (data.toInsure === '1') {
          window.location.href = data.redirectUrl;
          return false;
        }
        if (data.qrstatus === '03') {
          that.tipShow = false;
          that.qrcodeImageShow = false;
        } else {
          that.timer = setTimeout(function() {
            that.GetqueryResult();
          }, 10000);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
}

.decrypt-panel {
  margin-top: 100px;
  text-align: center;
}

.decrypt-tip {
  font-size: 18px;
  color: #333;
  margin-bottom: 40px;
}

.btnBX {
  width: 200px;
}

::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}

::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-footer {
  border-top: none;
}

#zxjHhdbQrcodeImage {
  display: block;
  width: 360px;
  height: 360px;
  margin: 80px auto;
}
</style>
